// 创建一个全局的提示工具对象
window.GlobalPrompt = {
  show(message, type = 'error', pageType = 'page') {
    // 获取所有提示元素
    const promptElements = document.querySelectorAll('.global-prompt');
    if (!promptElements.length) return;

    // 遍历所有提示元素并更新它们
    promptElements.forEach((promptElement) => {
      // 检查提示元素的类型
      const elementType = promptElement.getAttribute('data-type');

      // 如果元素类型与传入的pageType不匹配，跳过
      if (elementType !== pageType) {
        return;
      }

      // 隐藏所有其他提示
      promptElements.forEach((otherElement) => {
        if (otherElement !== promptElement) {
          otherElement.classList.remove('global-prompt-show');
        }
      });

      // 设置提示消息
      const messageElement = promptElement.querySelector('.global-prompt-message');
      if (messageElement) {
        messageElement.textContent = message;
      }

      // 根据类型添加对应的类名
      const promptContent = promptElement.querySelector('.global-prompt-content');
      if (promptContent) {
        promptContent.className = 'global-prompt-content';
        promptContent.classList.add(`global-prompt-${type}`);
      }

      // 先移除之前的类，以确保动画可以重新触发
      promptElement.classList.remove('global-prompt-show');

      // 强制重绘
      void promptElement.offsetWidth;

      // 显示提示
      promptElement.classList.add('global-prompt-show');

      // 3秒后隐藏
      setTimeout(() => {
        promptElement.classList.remove('global-prompt-show');
      }, 3000);
    });
  },
};
